<template lang="html">
  <div
    ref="header"
    v-tracking-context="{ page_type: webtrekkPageType }"
    class="fsd-header collapse align-middle align-justify row"
    @click="onAnyClick($event)"
  >
    <div
      v-tracking-context="{
        content_element: 'header',
        event_element: 'header_left'
      }"
      class="fsd-left fsd-header__list"
    >
      <div class="row align-middle align-justify collapse">
        <div
          v-show="resultsJobUserSelected"
          class="column shrink fsd-header-nav__unselect"
        >
          <button
            v-click-track="{ action_type: 'back', id: (job || {}).id }"
            class="fsd-header-nav__button"
            @click="resultsJobUserSelectedSet(false)"
          >
            <svg-icon
              icon-name="back-to-search"
              class-name="fsd-header-nav__back-to-search"
            />
          </button>
        </div>
        <div class="column grow">
          <a href="/" class="header__logo-link">
            <img
              :src="logo.src"
              class="logo"
              :class="logo.class || ''"
              :alt="logo.alt"
              :title="logo.alt"
            />
            <template v-if="jobMarket === 'ZEIT_JOBS'">
              <span class="zj-logo__title"> Stellenmarkt </span>
              <span class="zj-logo__coop">
                In Kooperation mit
                <img
                  :src="acLogoPath"
                  class="zj-logo__coop-logo"
                  alt="academics"
                />
              </span>
            </template>
          </a>
        </div>
        <div class="column shrink">
          <nav
            class="fsd-header-nav"
            :class="{ 'fsd-header-nav--detail-view': resultsJobUserSelected }"
          >
            <button
              class="fsd-header-nav__button fsd-header-nav__button--search"
              :class="{
                'fsd-header-nav__button--active':
                  isSearchVisible || isSearchSticky
              }"
              @click="onSearchClick"
            >
              <svg-icon icon-name="search-o" />
            </button>
            <a
              class="hide-for-large menu-toggle js-toggle-layout"
              data-toggle-class="menu-toggle--x"
              href="#"
              @click="onMenuToggle"
            >
              <div class="menu-toggle__bars">
                <span class="menu-toggle__bar" />
                <span class="menu-toggle__bar" />
                <span class="menu-toggle__bar" />
                <span class="menu-toggle__bar" />
              </div>
            </a>
          </nav>
        </div>
      </div>
    </div>
    <div class="fsd-right align-right">
      <nav class="nav nav--inline show-for-large">
        <div class="fsd-nav__bar">
          <a
            v-if="jobMarket === 'ZEIT_JOBS'"
            href="https://www.zeit.de/index"
            target="_blank"
            rel="nofollow noopener noreferrer"
            class="nav__link"
          >
            {{ 'client.header.nav.career_guide' | t }}
          </a>
          <a
            v-else
            href="#"
            class="nav__link js-toggle-career-guide"
            data-toggle-class="nav__link--career-guide"
          >
            {{ 'client.header.nav.career_guide' | t }}
          </a>

          <a v-if="isUserLoggedIn" class="nav__link" :href="searchProfilesLink">
            <svg-icon icon-name="private-area" class-name="nav__icon" />
            {{ 'client.header.nav.my_academics' | t }}
          </a>

          <a v-if="!isUserLoggedIn" class="nav__link" :href="signInLink">
            {{ 'client.header.nav.sign_in' | t }}
          </a>

          <a class="nav__link" :href="bookmarksLink">
            <svg-icon icon-name="bookmark" class-name="nav__icon" />
            {{ 'client.header.nav.bookmarks' | t }}
            <template v-if="isUserFullyLoggedIn">
              (<span class="js-bookmarks-total"
                ><span class="js-count">0</span></span
              >)
            </template>
          </a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import OffCanvas from '@/layout/off_canvas'
import BookmarkCounter from '@/bookmarks/bookmark_counter'
import ToggleSlide from '@/toggle/slide'
import { manualTrack } from '@/vue/directives/tracking'
import dachLogoPath from 'images/logos/academics.svg'
import comLogoPath from 'images/logos/aca-com.svg'
import zeitLogoPath from 'images/logos/zeit-z.svg'
import acLogoPath from 'images/logos/academics-white.svg'

const logos = {
  DACH: {
    src: dachLogoPath,
    alt: 'academics - Logo'
  },
  COM: {
    src: comLogoPath,
    alt: 'academics.com - Logo'
  },
  ZEIT_JOBS: {
    src: zeitLogoPath,
    alt: 'ZEIT Online - Logo',
    class: 'logo-zeit-z'
  }
}

export default {
  props: {
    webtrekkPageType: {
      type: String,
      default: null
    }
  },
  data: () => ({
    acLogoPath
  }),
  computed: {
    ...mapGetters(['isUserLoggedIn', 'isFilterVisible', 'isUserFullyLoggedIn']),
    ...mapState([
      'searchProfile',
      'resultsJobUserSelected',
      'isSearchVisible',
      'isSearchSticky',
      'jobMarket',
      'links',
      'job'
    ]),
    pillsTotal() {
      return (
        this.searchProfile.tagKeys.length + this.searchProfile.customTags.length
      )
    },
    logo() {
      return logos[this.jobMarket]
    },
    searchProfilesLink() {
      return this.links.searchProfiles
    },
    signInLink() {
      return this.links.signIn
    },
    bookmarksLink() {
      return this.links.bookmarks
    }
  },
  watch: {
    isUserFullyLoggedIn() {
      if (this.isUserFullyLoggedIn) {
        this.$nextTick(
          () => new BookmarkCounter($('.js-bookmarks-total'), this.$refs.header)
        )
      }
    }
  },
  mounted() {
    new OffCanvas(
      $('.js-layout'),
      $('.js-layout__off-canvas'),
      $('.js-layout__page'),
      $('.js-toggle-layout')
    )
    new ToggleSlide($('.js-toggle-career-guide'), $('.js-career-guide'))
    if (this.isUserFullyLoggedIn) {
      new BookmarkCounter($('.js-bookmarks-total'), this.$refs.header)
    }
  },
  methods: {
    ...mapMutations(['resultsJobUserSelectedSet', 'searchStickyToggle']),
    ...mapActions(['filterToggle']),

    onSearchClick(e) {
      if (this.isSearchVisible && !this.isSearchSticky) {
        if (this.isFilterVisible) {
          manualTrack(e.currentTarget, { action_type: 'filter_toggle_off' })
          this.filterToggle()
        }
        manualTrack(e.currentTarget, { action_type: 'search_focus' })
        this.$VueEventBus.emit('search__headerSearchButton--nonStickyClicked')
      } else {
        if (this.isFilterVisible) {
          manualTrack(e.currentTarget, { action_type: 'search_toggle_on' })
          manualTrack(e.currentTarget, { action_type: 'filter_toggle_off' })
          this.filterToggle()
        } else {
          manualTrack(e.currentTarget, {
            action_type: `search_toggle_${this.isSearchSticky ? 'off' : 'on'}`
          })
          this.searchStickyToggle()
        }
      }
    },
    // complementing main screen area of fused app
    onAnyClick(event) {
      this.$VueEventBus.emit('globalBlur', event)
    },
    onMenuToggle(e) {
      const isOpen = $('.js-toggle-layout').hasClass('menu-toggle--x')
      manualTrack(e.currentTarget, {
        action_type: `off_canvas_menu_toggle_${isOpen ? 'off' : 'on'}`
      })
    }
  }
}
</script>
